import { combineReducers } from "redux";
import bidhurBidhuwa from "./bidhurBidhuwa.reducer";

const logicalInvalidReducer = combineReducers({
  bidhurBidhuwa
});

export default logicalInvalidReducer;
